export default "__VITE_ASSET__DFHfZ0Ie__"